import { actions } from './actions'

const initialState = {
  paisesInfo: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function paisesInfoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PAISES_INFO_LOAD_REQUESTED:
      return { ...state, paises: { ...state.paisesInfo, loading: true } }
    case actions.PAISES_INFO_LOAD_SUCCEEDED:
      return {
        ...state,
        paisesInfo: { ...state.paisesInfo, data: action.payload, loading: false },
      }
    case actions.PAISES_INFO_LOAD_FILED:
      return {
        ...state,
        paisesInfo: { ...state.paisesInfo, loading: false, error: action.error },
      }

    case actions.PAISES_INFO_FILTERED_REQUESTED:
      return { ...state, paises: { ...state.paisesInfo, loading: true } }
    case actions.PAISES_INFO_FILTERED_SUCCEEDED:
      return {
        ...state,
        paisesInfo: { ...state.paisesInfo, data: action.payload, loading: false },
      }
    case actions.PAISES_INFO_FILTERED_FILED:
      return {
        ...state,
        paisesInfo: { ...state.paisesInfo, loading: false, error: action.error },
      }

    default:
      return state
  }
}
